import { render } from "./RulesPage.vue?vue&type=template&id=35a469d2"
import script from "./RulesPage.vue?vue&type=script&lang=js"
export * from "./RulesPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__